export const statusOptions = [
  { text: "Active", value: 1 },
  { text: "Inactive", value: 2 },
];
